<template>
  <div class="public-cv flex-column-center">
    <div v-if="onlineVisibility" class="online-cv-info hide-cv flex-between">
      <p class="flex-center">
        <span class="iconfont iconeye-off"/>
        <span class="text">无法获得推荐机会</span>
      </p>
      <div class="flex-center">
<!--        <p class="hide-item flex-center info-complete" v-if="completeState" @click.stop="toOnlineCvBase">-->
<!--          <span class="iconfont iconcvs-gengxin"/>-->
<!--          <span>更新</span>-->
<!--&lt;!&ndash;          <span>信息待完善</span>&ndash;&gt;-->
<!--        </p>-->
        <p class="hide-item flex-center" @click.stop="updateOnlineCv" v-if="updateShow || completeState">
          <span class="iconfont iconcvs-gengxin"/>
          <span>更新</span>
        </p>
        <p class="hide-item flex-center" @click.stop="toSetVisibility">
          <span class="iconfont iconsettings"/>
          <span>设置</span>
        </p>
      </div>
    </div>
    <div v-else-if="hasOnlineCv && cvInfo">
      <div class="online-cv-info flex" @click="toPreview">
        <div class="img-wrapper flex-center">
          <img class="avatar" v-if="cvInfo.profile.avatar_url" :src="cvInfo.profile.avatar_url" alt="">
          <img class="cv-logo" v-else src="https://files.wondercv.com/mobile/cvs/cv-logo.png" alt="">
        </div>
        <div class="information">
          <p class="username">{{ cvInfo.profile.username }}</p>
          <p v-if="(cvInfo.work_experiences.length || cvInfo.internship_experiences.length) && !userData.is_student" class="experience">
            <span>{{ cvInfo.work_experiences[0].title || cvInfo.internship_experiences[0].title }}</span>
          </p>
          <p v-else-if="cvInfo.education_experiences.length" class="experience">
            <span v-if="uniSchool">{{ uniSchool }}</span>
            <span v-if="degree">{{ degree }}</span>
          </p>
          <p class="update-time">{{ updateTime }}</p>
        </div>
        <img class="online-logo" src="https://files.wondercv.com/online_cv/online-logo.png" alt="">
<!--        <p class="hide-item flex-center online-cv-update info-complete" @click.stop="toOnlineCvBase"-->
<!--           v-if="completeState">-->
<!--          <span class="iconfont iconcvs-gengxin"/>-->
<!--&lt;!&ndash;          <span>信息待完善</span>&ndash;&gt;-->
<!--          <span>更新</span>-->
<!--        </p>-->
        <p class="hide-item flex-center online-cv-update" @click.stop="updateOnlineCv" v-if="updateShow || completeState">
          <span class="iconfont iconcvs-gengxin"/>
          <span>更新</span>
        </p>
      </div>
    </div>
    <div v-else class="online-cv flex-between">
      <span class="text">开启推荐，让工作找你</span>
      <button class="setting-btn" @click="settingOnlineCv">点击开启</button>
    </div>
    <div class="bottom-container">
      <div class="bottom-slider"></div>
    </div>
    <div class="online-cv-bottom"></div>
    <update-version :version-show="versionShow" @maskClose="versionShow = false"/>
  </div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import Cookies from 'js-cookie'
	import { envMixin } from '../../assets/js/mixin/global'
	import updateVersion from '../../components/ios/update-version'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { onlineMixin } from '../../assets/js/mixin/cv'
	import { userMixin } from '../../assets/js/mixin/user'

	let moment = require('moment')

	export default {
		name: 'public-cv',
		mixins: [ envMixin, componentsMixin, onlineMixin, userMixin ],
		props: {
			cvsData: {
				type: Array,
				default: () => []
			}
		},
		data () {
			return {
				versionShow: false,
				completeState: false
			}
		},
		async mounted () {
			this.cvIntegrity()
		},
		computed: {
			...mapState('cv', [ 'onlineCvData', 'onlineVisibility', 'onlineCvValid' ]),
			// 是否有在线简历
			hasOnlineCv () {
				if (this.onlineCvData && Object.keys(this.onlineCvData).length && !this.onlineVisibility) {
					return Object.keys(this.onlineCvData).length
				}
			},
			// 在线简历数据
			cvInfo () {
				if (this.hasOnlineCv) {
					return this.onlineCvData.resume.info
				}
			},
			// 在线简历更新时间
			updateTime () {
				if (this.hasOnlineCv) return `${ moment(this.onlineCvData.resume.updated_at).format('YYYY年MM月DD日 HH:mm') } 更新`
			},
			// 中文非导师简历列表
			cnCvsData () {
				return this.cvsData.filter(item => item.lang === 'cn' && !item.is_mentor)
			},
			// 是否显示更新按钮
			updateShow () {
				let onlineCvTime = this.hasOnlineCv ? moment(this.onlineCvData.resume.updated_at).format('YYYYMMDDHHmmss') : this.onlineCvData.updated_at && moment(this.onlineCvData.updated_at).format('YYYYMMDDHHmmss')

				for (let i = 0; i < this.cnCvsData.length; i++) {
					let cvTime = moment(this.cnCvsData[i].update_time).format('YYYYMMDDHHmmss')
					if (cvTime > onlineCvTime) return true
				}
			},
			// 在线简历教育学校
			uniSchool () {
				if (this.cvInfo.education_experiences.length) {
					return this.cvInfo.education_experiences[0].cust_uni_name || this.cvInfo.education_experiences[0].school.cn
				}
			},
			// 在线简历学历
			degree () {
				if (this.cvInfo.education_experiences.length) {
					return this.cvInfo.education_experiences[0].cust_degree || this.cvInfo.education_experiences[0].degree_name.cn
				}
			}
		},
		watch: {},
		components: {
			updateVersion
		},
		methods: {
			...mapActions('cv', [ 'getOnlineCvData', 'getVisibility', 'checkCvValid' ]),
			// 更新在线简历
			updateOnlineCv () {
				if (this.onlineVisibility) {
					this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '更新简历后，简历将推荐给 HR<br>确认更新？',
						onConfirm: this._updateOnlineCv
					}).show()
				} else {
					this._updateOnlineCv()
				}
			},
			// 设置在线简历
			settingOnlineCv () {
				this.$emit('setOnlineCv')
				// this.routeTo('/cvs/online/list')
			},
			// 在线简历预览
			toPreview () {
				this.routeTo(`/cvs/online/${ this.onlineCvData.resume.token }/preview`)
			},
			// 设置在线简历私密度
			toSetVisibility () {
				this.routeTo(`/account/privacy`)
			},
			// 更新在线简历接口
			async _updateOnlineCv () {
				let list = this.cvsData.filter(item => item.lang === 'cn' && !item.is_mentor && item.can_editable)
				if (list.length === 1) {
					const token = this.cnCvsData[0].token
          if (this.completeState) {
	          this.routeTo(`/cvs/online/${ token }/base`)
          } else {
	          await this.saveOnlineCv(token)
	          this.getVisibility(this.cvAccountToken)
          }
				} else {
					this.routeTo(`/cvs/online/list`)
				}
			},
			// 校验当前简历是否完整
			async cvIntegrity () {
				let validAry = this.onlineCvValid && Object.keys(this.onlineCvValid)
				if (validAry.length) {
					if (!validAry.every(item => this.onlineCvValid[item])) {
						this.completeState = true
					}
				}
			},
			// 跳转至在线简历完善信息页
			toOnlineCvBase () {
				if (this.onlineVisibility) {
					this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '更新简历后，简历将推荐给 HR<br>确认更新？',
						onConfirm: this._toOnlineCvBase
					}).show()
				} else {
					this._toOnlineCvBase()
				}
			},
			// 跳转逻辑
			_toOnlineCvBase () {
				if (this.onlineCvData) {
					let list = this.cvsData.filter(item => item.lang === 'cn' && !item.is_mentor && item.can_editable)
					let token = list.length ? list[0].token : null
					if (token) this.routeTo(`/cvs/online/${ token }/base`)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .public-cv {
    margin-bottom: 18px;
    .online-cv-info {
      width: calc(100vw - 24px);
      padding: 22px 0 22px 18px;
      background-color: #595B6E;
      border-radius: 8px 8px 0 0;
      position: relative;
      .img-wrapper {
        width: 76px;
        height: 76px;
        background-color: $color-light;
        border-radius: 4px;
        margin-right: 10px;
        .avatar {
          border-radius: 4px;
          width: 76px;
          height: 76px;
          object-fit: cover;
        }
        .cv-logo {
          width: 30px;
        }
      }
      .information {
        position: relative;
        z-index: 3;
        .username {
          color: #babac8;
          margin-bottom: 22px;
        }
        .experience {
          margin-bottom: 10px;
          span {
            font-size: $font-size-medium-x;
            color: $color-light;
            &::after {
              content: '|';
              margin: 0 6px;
            }
            &:last-child::after {
              content: '';
            }
          }
        }
        .update-time {
          color: #babac8;
          font-size: $font-size-small;
        }
      }
      .online-logo {
        position: absolute;
        right: 0;
        width: 106px;
      }
      .iconeye-off {
        color: #FEFEFE;
        margin-right: 8px;
      }
    }
    .online-cv {
      position: relative;
      z-index: 7;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, .12);
      background-color: #595B6E;
      color: $color-light;
      width: calc(100vw - 24px);
      border-radius: 8px 8px 0 0;
      padding: 8px 24px 0;
      .text {
        line-height: 14px;
      }
      .setting-btn {
        background-color: $color-light;
        border-radius: 12px;
        padding: 4px 14px;
        font-size: $font-size-small;
        color: #4D4F5F;
        outline: none;
        border: none;
      }
    }
    .bottom-container {
      position: relative;
      width: calc(100vw - 24px);
      height: 10px;
      overflow: hidden;
      z-index: 7;
      .bottom-slider {
        position: absolute;
        bottom: 0;
        z-index: 8;
        left: 50%;
        transform: translateX(-50%);
        width: 150%;
        background-color: #595B6E;
        border-radius: 8px 8px 85% 85%;
        height: 60px;
      }
    }
    .online-cv-bottom {
      position: relative;
      top: -10px;
      height: 6px;
      z-index: 6;
      width: 100vw;
      background-color: $color-light;
      box-shadow: 0 -5px 5px rgba($color: #858585, $alpha: 0.1);
    }
    .hide-cv {
      padding: 16px 16px 13px;
      .text {
        color: #babac8;
      }
    }
    .hide-item {
      background-color: $color-light;
      font-size: $font-size-small;
      width: 62px;
      height: 22px;
      border-radius: 12px;
      color: #4D4F5F;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
      .iconfont {
        font-size: 14px;
        color: #515364;
        margin-right: 4px;
        font-weight: bold;
      }
    }
    .online-cv-update {
      position: absolute;
      top: 20px;
      right: 16px;
      z-index: 3;
    }
    .info-complete {
      width: 82px;
      padding: 6px 10px;
      color: #4D4F5F;
      font-size: $font-size-small;
      white-space: nowrap;
    }
  }
</style>
